import React from "react";
import { Alert, AlertProps } from "antd";

import * as style from "./AlertStyle.module.scss"

const AlertBox = (props: AlertProps) => {
  return (
    <div className={style.alert}>
      <Alert {...props} />
    </div>
  );
};

export default AlertBox;
